import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { GerminationVerificationPage } from "@/features/quality/components/germination/germination-verification-page";

const search = z.object({
  // The To set up tab is gone (user, 2026-10-23); an old link to it lands on Pending.
  tab: z
    .enum(["in_lab", "pending", "verified", "not_cleared"])
    .default("pending")
    .catch("pending"),
  view: z.enum(["lot", "srf"]).optional(),
  srfNo: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  doe: z.string().optional(),
  // In the lab: one analyst's trays, and the step pending (QC review, 2026-11-03).
  analystId: z.number().int().positive().optional().catch(undefined),
  step: z.enum(["setup", "evaluation"]).optional().catch(undefined),
  // The finished tab's page; the live tabs scroll.
  page: z.number().int().min(1).default(1).catch(1),
});

export const Route = createFileRoute("/_app/quality/germination/")({
  validateSearch: search,
  // The Lab Manager may hold only the setup (user, 2026-10-22); they see every tab but verify
  // nothing (user, 2026-10-23: "only to setup tab is showing").
  beforeLoad: () => {
    const { can } = useAuth.getState();
    if (!can("qc.verify") && !can("qc.germination_setup"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <GerminationVerificationPage
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
